import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../store/slices/editModalSlice";
import { openModalDelete } from "../../store/slices/deleteModalPackageSlice";
import InfoModal from "../Modals/InfoModal";
import DeleteModalPackage from "../Modals/DeleteModal/DeleteModalPackage";
import EditModalPackage from "../Modals/EditModal/EditModalPackage";

const TableItemsPackageResponsive = ({ dataPackage }) => {
  const dispatch = useDispatch();
  const editModalState = useSelector((state) => state.editModalPackage);

  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  return (
    <>
      <div className="block sm:hidden space-y-4">
        {dataPackage?.data?.map((item) => (
          <div
            key={item.id}
            className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
          >
            <p>
              <strong>Emri:</strong> {item.name}
            </p>
            <p>
              <strong>Kategoria:</strong> {item.categoryName}
            </p>
            <p>
              <strong>Çmimi:</strong> {item.price}.00 €
            </p>
            <p>
              <strong>Çmimi i Autoshkollës:</strong> {item.schoolPrice}.00 €
            </p>
            <p>
              <strong>Çmimi i Adminit:</strong> {item.adminPrice}.00 €
            </p>
            <p>
              <strong>Koha:</strong> {item.month} muaj
            </p>

            <div className="flex flex-wrap gap-2 pt-2">
              <button className="text-blue-500">
                <InfoModal
                  title="Info rreth testit"
                  name="Emri i testit"
                  categoryInInfo="Kategoria e testit"
                />
              </button>

              <button
                onClick={() => handleEditItem(item.id)}
                className="text-green-600"
              >
                <EditModalPackage
                  id={item.id}
                  title="Edito një pako"
                  submitButtonText="Edito pakon"
                  namePackage="Emri i pakosë"
                  packageCategory="Lloji i kategorisë"
                  priceValue="Cmimi"
                  adminValue="Cmimi i adminit"
                  schoolValue="Cmimi i autoshkolles"
                  isOpen={editModalState[item.id] === true}
                />
              </button>

              <button
                onClick={() => handleDeleteItem(item.id)}
                className="text-red-500"
              >
                <DeleteModalPackage id={item.id} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TableItemsPackageResponsive;
